// 仕様: データ管理用のRedux Slice
// 各種データ（店舗情報、日付選択、フィルター等）の状態を一元管理
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface DataState {
  tenpoCode: string | null;
  tenpoName: string;
  date: string;
  selectedDate: string;
  weekDateOptions: string[];
  weekDateValue: string;
  pmaCode: string;
  pmaName: string;
}

const initialState: DataState = {
  tenpoCode: null,
  tenpoName: '',
  date: '',
  selectedDate: '',
  weekDateOptions: [],
  weekDateValue: '',
  pmaCode: '',
  pmaName: '',
};

export const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    // 店舗コード設定
    setTenpoCode: (state, action: PayloadAction<string | null>) => {
      state.tenpoCode = action.payload;
    },
    // 店舗名設定
    setTenpoName: (state, action: PayloadAction<string>) => {
      state.tenpoName = action.payload;
    },
    // 日付設定
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload;
    },
    // 選択日付設定
    setSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
    },
    // 週間日付オプション設定
    setWeekDateOptions: (state, action: PayloadAction<string[]>) => {
      state.weekDateOptions = action.payload;
    },
    // 週間日付値設定
    setWeekDateValue: (state, action: PayloadAction<string>) => {
      state.weekDateValue = action.payload;
    },
    // PMAコード設定
    setPmaCode: (state, action: PayloadAction<string>) => {
      state.pmaCode = action.payload;
    },
    // PMA名設定
    setPmaName: (state, action: PayloadAction<string>) => {
      state.pmaName = action.payload;
    },
    // データリセット
    resetData: (state) => {
      return initialState;
    },
  },
});

export const {
  setTenpoCode,
  setTenpoName,
  setDate,
  setSelectedDate,
  setWeekDateOptions,
  setWeekDateValue,
  setPmaCode,
  setPmaName,
  resetData,
} = dataSlice.actions;

// セレクター
export const selectTenpoCode = (state: RootState) => state.data.tenpoCode;
export const selectTenpoName = (state: RootState) => state.data.tenpoName;
export const selectDate = (state: RootState) => state.data.date;
export const selectSelectedDate = (state: RootState) => state.data.selectedDate;
export const selectWeekDateOptions = (state: RootState) => state.data.weekDateOptions;
export const selectWeekDateValue = (state: RootState) => state.data.weekDateValue;
export const selectPmaCode = (state: RootState) => state.data.pmaCode;
export const selectPmaName = (state: RootState) => state.data.pmaName;

export default dataSlice.reducer;
